import { useSelectors } from '@exodus/headless-react';
import lodash from 'lodash';
import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import useFromWalletAccount from './use-from-wallet-account.js';
const { keyBy } = lodash;
const useExchangeFromAssets = () => {
    const selectors = useSelectors();
    const [fromWalletAccount] = useFromWalletAccount();
    const supportedFromAssetIds = useSelector(selectors.exchange.fromAssetIds);
    const [loading, setLoading] = useState(false);
    const allAssets = useSelector(selectors.assets.all);
    const enabledAssetNamesForWalletAccount = useSelector(selectors.assetSources.createEnabledAssetsByWalletAccount(fromWalletAccount));
    useEffect(() => {
        setLoading(supportedFromAssetIds.length === 0);
    }, [supportedFromAssetIds.length]);
    const value = useMemo(() => {
        const enabledAssetsForWalletAccount = [...enabledAssetNamesForWalletAccount].map((assetName) => allAssets[assetName]);
        const assetsByTicker = keyBy(enabledAssetsForWalletAccount, 'ticker');
        return supportedFromAssetIds
            .map((from) => assetsByTicker[from])
            .filter((asset) => asset?.ticker);
    }, [allAssets, enabledAssetNamesForWalletAccount, supportedFromAssetIds]);
    return useMemo(() => ({ value, loading }), [value, loading]);
};
export default useExchangeFromAssets;
